var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.999,
    cy: 19.999,
    r: 20,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0958 30.786H10.4377C9.79094 30.786 9.17065 30.5291 8.7133 30.0717C8.25596 29.6144 7.99902 28.9941 7.99902 28.3473V19.8119C7.99902 19.1651 8.25596 18.5448 8.7133 18.0875C9.17065 17.6301 9.79094 17.3732 10.4377 17.3732H14.0958M22.6312 14.9345V10.0571C22.6312 9.08692 22.2458 8.15648 21.5598 7.47046C20.8738 6.78445 19.9433 6.39905 18.9732 6.39905L14.0958 17.3732V30.786H27.85C28.4381 30.7927 29.0089 30.5865 29.457 30.2056C29.9051 29.8247 30.2005 29.2946 30.2887 28.7131L31.9714 17.739C32.0245 17.3895 32.0009 17.0326 31.9023 16.6931C31.8038 16.3536 31.6326 16.0396 31.4006 15.7728C31.1686 15.506 30.8814 15.2929 30.5589 15.1481C30.2364 15.0034 29.8862 14.9305 29.5327 14.9345H22.6312Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.d29f9be997ee67cee0d1bbe0854bc80f.svg";
export { ForwardRef as ReactComponent };